export const ROUTE_PATH = {
  home: '/plan',
  plan: 'createPlan',
};
